import React from 'react';
// Подсветка корпуса — та же, что у ежедневного приглашения (цвет алмазной
// лиги), и кнопка — того же алмазного цвета, что кнопка битвы в меню; стили
// подключаем и здесь, иначе на странице теста модалок их нет
import '../AiMatchPromoModal/AiMatchPromoModal.css';
import '../../MainMenu/AiMatchMenuButton/AiMatchMenuButton.css';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';
import {AI_MATCH_TITLE, AI_PROMO_IMAGE_PATH} from '../../../configs/aiMatch';
import {getAiPromoOpensTimes} from '../../../utils/aiPromo/getAiPromoOpensTimes';
import {
  TEXT_AI_MATCH_NEWS_CALL,
  TEXT_AI_MATCH_NEWS_INTRO,
  TEXT_AI_MATCH_NEWS_INTRO_END,
  TEXT_AI_MATCH_NEWS_MODEL,
  TEXT_AI_MATCH_NEWS_MSK_SUFFIX,
  TEXT_AI_MATCH_NEWS_OK,
  TEXT_AI_MATCH_NEWS_START_PREFIX,
  TEXT_AI_MATCH_NEWS_TITLE,
  TEXT_AI_MATCH_NEWS_UPDATE_INTRO,
  TEXT_AI_MATCH_NEWS_UPDATE_INTRO_END,
  TEXT_AI_MATCH_NEWS_UPDATE_TITLE,
} from '../../../constants/text/aiMatch';

const PAGE_ID = 'AiMatchNewsModal';

/**
 * Разовый анонс в главном меню: «Битва с AI Claude Opus» теперь ежедневная и
 * открыта всем игрокам, начало — в 21:00 по Москве (по часам игрока — его
 * время и московское в скобках). Корпус, картинка и подсветка — те же, что у
 * ежедневного приглашения (AiMatchPromoModal); кнопка одна — «Понятно»:
 * вести из анонса некуда, в матч зовет приглашение в само время набора.
 *
 * Анонс показывается один раз на редакцию (aiMatchNewsVersion.js): когда
 * время начала меняется, его снова видят все. Игроку, уже закрывшему прежнюю
 * редакцию (isUpdate), заголовок и первая строка говорят о новом времени, а
 * не знакомят с событием заново; строка времени и призыв — те же.
 *
 * Кому и когда показывать, решает меню (checkIfAiMatchNewsDue и
 * checkIfAiMatchNewsOpenable): один раз на аккаунт и редакцию, когда промо
 * игроку открыто, ниже остальных модалок меню и не во время набора в лобби дня.
 * Закрытие ведет в onClose — там меню ставит отметку показа в профиле. Сама
 * модалка на сервер не ходит: ее же открывает превью в админке
 * (AdminModalsTestPage)
 *
 * @param {Function} onClose
 * @param {boolean} [isUpdate] - игрок уже закрывал прежнюю редакцию анонса
 * @param {number} [serverTimeDelta] - поправка часов: время сервера = Date.now() + она
 * @param {number} [timezoneOffsetMinutes] - пояс игрока (по умолчанию браузера);
 *   для тестов и превью
 */
const AiMatchNewsModal = ({onClose, isUpdate = false, serverTimeDelta = 0, timezoneOffsetMinutes}) => {
  const {mskTime, localTime} = getAiPromoOpensTimes(Date.now() + serverTimeDelta, timezoneOffsetMinutes);

  return (
    <MenuPromoModal
      pageId={PAGE_ID}
      title={isUpdate ? TEXT_AI_MATCH_NEWS_UPDATE_TITLE : TEXT_AI_MATCH_NEWS_TITLE}
      imagePath={AI_PROMO_IMAGE_PATH}
      imageAlt={AI_MATCH_TITLE}
      modalClassName={'ai-match-promo-modal'}
      titleClassName={'text-diamond'}
      hideLabel={TEXT_AI_MATCH_NEWS_OK}
      hideButtonId={'ok'}
      hideButtonClassName={'main-menu-button_ai-match main-menu-button_ai-match-promo-modal'}
      onClose={onClose}
    >
      <p className={'menu-promo-modal_text'}>
        {isUpdate ? TEXT_AI_MATCH_NEWS_UPDATE_INTRO : TEXT_AI_MATCH_NEWS_INTRO}
        <span className={'text-diamond'}>{TEXT_AI_MATCH_NEWS_MODEL}</span>
        {isUpdate ? TEXT_AI_MATCH_NEWS_UPDATE_INTRO_END : TEXT_AI_MATCH_NEWS_INTRO_END}
      </p>
      <p className={'menu-promo-modal_text ai-match-promo-modal_start'}>
        {TEXT_AI_MATCH_NEWS_START_PREFIX}{' '}
        {localTime ? (
          <>
            <span className={'text-diamond'}>{localTime}</span> ({mskTime} {TEXT_AI_MATCH_NEWS_MSK_SUFFIX})
          </>
        ) : (
          <>
            <span className={'text-diamond'}>{mskTime}</span> {TEXT_AI_MATCH_NEWS_MSK_SUFFIX}
          </>
        )}
      </p>
      <p className={'menu-promo-modal_text'}>{TEXT_AI_MATCH_NEWS_CALL}</p>
    </MenuPromoModal>
  );
};

export default AiMatchNewsModal;
